export const mortgagePmiCalculatorData = [
  {
    id: 1,
    heading:
      "Home Loan Eligibility Calculator - Instantly Check Your Eligibility Today!",
    subHeading:
      "Now that you’ve used Minemi’s Home Loan Eligibility Calculator and seen your results, it’s time to dive deeper into what those numbers mean and how you can use them to make informed financial decisions. This section will guide you through the key factors influencing your eligibility, the benefits of understanding your home loan eligibility potential, and actionable steps to enhance your borrowing power.",
    headingTwo: "How to use the home loan elgibility calculator",
    notice:
      "Some or all of the home loan eligiblity lenders featured on our site are advertising partners of NerdWallet, but this does not influence our evaluations, lender star ratings or the order in which lenders are listed on the page. Our opinions are our own. Here is a list of our partners.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];

export const stepOneData = [
  {
    heading: "What Your Home Loan Eligibility Results Mean",
    // paras before heading
    paraOne:
      "The results you just viewed are based on your income, expenses, loan tenure, and interest rate inputs. Here’s how to interpret them:",

    mortgage_eligibility: [
      {
        head: "Eligible Loan Amount: ",
        info: "This is the maximum amount lenders are likely to offer you based on your financial profile.",
      },
      {
        head: "Affordable EMI: ",
        info: "This shows the monthly repayment you can comfortably manage without overburdening your finances.",
      },
      {
        head: "Loan Tenure and Interest Rate Impact: ",
        info: "Longer tenures reduce monthly EMIs but increase overall interest, while shorter tenures lead to higher EMIs but save on interest costs.",
      },
    ],

    //   paras after heading

    paraTwo:
      "Use these insights to align your expectations with market options and plan the next steps in your home loan eligibility journey.",

    headingTwo: "Factors That Impact Your Home Loan Eligibility",
    subheadTwo:
      "Understanding the underlying factors influencing your eligibility can help you optimize your finances and improve your chances of approval:",

    infoList: [
      {
        heading: "Income and Fixed Obligations: ",
        description:
          " Your eligibility largely depends on your disposable income—the amount left after deducting existing loan EMIs, rent, or other recurring expenses. Keeping your Fixed Obligation to Income Ratio (FOIR) below 40%-50% is key to maximizing eligibility.",
      },
      {
        heading: "Credit Score: ",
        description:
          "Your credit score is a reflection of your creditworthiness. A higher score (750 or above) not only improves your eligibility but also helps you secure better interest rates. ",
      },
      {
        heading: " Loan Tenure: ",
        description:
          "Longer loan tenures reduce EMIs, making you more eligible. However, they increase total interest costs. Choosing the right tenure is crucial for balancing affordability and savings.",
      },
      {
        heading: " Age and Employment Stability: ",
        description:
          " Younger applicants with stable income sources—such as salaried or self-employed professionals—are generally eligible for higher loan amounts.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "How to Use Your Home Loan Eligibility Results",
    subhead:
      "Here’s how you can turn your eligibility results into actionable steps:",
    infoList: [
      {
        heading: "Plan Your Home Budget:",
        description:
          "  Use the eligible loan amount as a starting point to set a realistic budget for your home purchase. ",
      },
      {
        heading: "Compare Lenders:",
        description:
          "  Different lenders may offer varied interest rates and terms for the same eligibility. Compare options to find the best deal. ",
      },
      {
        heading: "Adjust Loan Tenure:",
        description:
          " If the EMI seems high, consider extending the loan tenure to reduce monthly payments.",
      },
      {
        heading: " Optimize Fixed Obligations:",
        description:
          " Reduce smaller debts or unnecessary expenses to improve your FOIR and increase eligibility.",
      },
    ],

    headTwo: "Benefits of Understanding Your Home Loan Eligibility",
    headTwoInfoList: [
      {
        heading: "Informed Decision-Making: ",
        description:
          "Knowing your borrowing capacity upfront allows you to focus on properties within your budget, saving time and effort.",
      },
      {
        heading: "Better Negotiation Power: ",
        description:
          "With a clear understanding of your eligibility, you can confidently negotiate with lenders for better terms and interest rates. ",
      },
      {
        heading: "  Financial Planning: ",
        description:
          "Planning your finances becomes easier when you know the potential EMI burden and how it fits into your monthly budget.",
      },
    ],
    Tips: "Tips to Improve Your Home Loan Eligibility",
    tipsSubhead:
      "If your eligibility doesn’t match your expectations, here are ways to enhance it:",
    tipsInfoList: [
      {
        heading: " Improve Your Credit Score: ",
        description:
          "Pay existing debts on time, avoid multiple credit inquiries, and reduce credit card utilization.",
      },
      {
        heading: "Lower Fixed Obligations: ",
        description:
          " Pay off smaller loans or credit card dues to free up income for home loan eligibility repayment. ",
      },
      {
        heading: "  Add a Co-Applicant: ",
        description:
          "A joint application with a spouse or family member can increase eligibility by combining incomes.",
      },
      {
        heading: "Choose a Longer Tenure: ",
        description:
          " Extending the repayment period reduces EMI amounts, increasing loan affordability.",
      },
      {
        heading: "Compare Interest Rates:  ",
        description:
          "  Look for lenders offering competitive rates and minimal additional charges.",
      },
    ],
  },
  {
    paraOne: "Take Control of Your Home Buying Journey",
    paraTwo:
      "Using Minemi’s Home Loan Eligibility Calculator is just the first step in your homeownership journey. With clear insights and actionable recommendations, you’re now better equipped to make informed decisions. Start comparing lenders, optimize your financial profile, and turn your dream of owning a home into reality.",
    paraThree:
      "Let Minemi be your partner in simplifying mortgages—helping you make smarter, faster, and better financial choices.",
  },
];
